import { useCallback, useEffect, useRef } from 'react';
import { CONFIRM_GUARD_MS } from '../components/shared/CancelTaskConfirm';

/**
 * The confirm guard every destructive "Are you sure?" shares (ConfirmDialog,
 * CancelTaskConfirm): the second click of a double-click, and any click
 * within CONFIRM_GUARD_MS of the confirm appearing, are ignored.
 *
 *   const guard = useConfirmGuard(open);
 *   <button onClick={guard(doDelete)}>Delete</button>
 */
export default function useConfirmGuard(open) {
    const openedAt = useRef(0);
    useEffect(() => {
        if (open) openedAt.current = Date.now();
    }, [open]);
    return useCallback((fn) => (e) => {
        if (e?.detail > 1 || Date.now() - openedAt.current < CONFIRM_GUARD_MS) return;
        fn(e);
    }, []);
}
